
import CaseStudies from './../../components/home/illustration/icons/CaseStudies'
import PanelDashboard from './../../components/home/illustration/icons/PanelDashboard'
import PolicyDocuments from './../../components/home/illustration/icons/PolicyDocuments'
import PricingMatrix from './../../components/home/illustration/icons/PricingMatrix'
import TAASIcon from './../../components/home/illustration/icons/TAAS'
import ProcessDocuments from './../../components/home/illustration/icons/ProcessDocuments'
import Services from './../../components/home/illustration/icons/Services'
import { ROUTES } from '../../config/routes'

export const KEYS = {
    SERVICES: "services",
    PROCESS_DOCUMENTS: "processDocuments",
    POLICY_DOCUMENTS: "policyDocuments",
    CASE_STUDIES: "caseStudies",
    PANEL_DASHBOARD: 'panelDashboard',
    PRICING_MATRIX: 'pricingMatrix',
    TAAS: 'taas'
}

export const defaultHomeData = [
    {
        id: KEYS.SERVICES,
        Icon: Services,
        text: "Our capabilities",
        className: "Consumer",
        firstRowText: <>our</>,
        secondRowText: 'CAPABILITIES',
        paragraph: "Research solutions customized as per your needs, click to view- What we do?",
        link: ROUTES.OUR_CAPABILITIES.ROOT
    },
    {
        id: KEYS.TAAS,
        Icon: TAASIcon,
        text: "Team as a service",
        className: "Healthcare LandingPageTheme",
        firstRowText: <>Team as</>,
        secondRowText: 'A service',
        paragraph: "Research solutions customized as per your needs, click to view- What we do?",
        link: `#`
    },
    {
        id: KEYS.PROCESS_DOCUMENTS,
        Icon: ProcessDocuments,
        text: "Best Practices",
        className: "Consumer",
        firstRowText: 'best',
        secondRowText: 'PRACTICES',
        paragraph: "From Recruitment to Quality check, click to view- How we do it?",
        link: ROUTES.PROCESS_DOCUMENTS
    },
    {
        id: KEYS.POLICY_DOCUMENTS,
        Icon: PolicyDocuments,
        text: "Guidelines",
        className: "Consumer",
        firstRowText: "CODES &",
        secondRowText: 'GUIDELINES',
        paragraph: "Complying to global market research regulations, click to view- Our policy documents.",
        link: `${ROUTES.POLICY_DOCUMENTS.ROOT}/${ROUTES.POLICY_DOCUMENTS.CODE_OF_MARKET_RESEARCH}`
    },
    {
        id: KEYS.CASE_STUDIES,
        Icon: CaseStudies,
        text: "Client Stories",
        className: "Consumer",
        firstRowText: <>CLIENT <br /> RESULTS</>,
        secondRowText: 'STORIES',
        paragraph: "Our credentials are the impact our data creates, click to view- Our Success Stories.",
        link: ROUTES.CASE_STUDY.ROOT
    },
    {
        id: KEYS.PANEL_DASHBOARD,
        Icon: PanelDashboard,
        text: "Our Reach",
        className: "Consumer",
        firstRowText: 'OUR',
        secondRowText: 'REACH',
        paragraph: "31M+ B2B and B2C respondents, all at your disposal, click to view- Our Panel Reach.",
        link: "#"
    },
    {
        id: KEYS.PRICING_MATRIX,
        Icon: PricingMatrix,
        text: "Our Pricing",
        className: "Consumer",
        firstRowText: 'OUR',
        secondRowText: 'PRICING',
        paragraph: "We take care of your research needs and budget, click to view- Our Pricing Matrix",
        link: ROUTES.PRICING_MATRIX.ROOT
    },
]

